/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ClickOutside from '@/utils/click-outside';
export default {
  name: 'tp-popover',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.init();

      window.addEventListener('resize', _this.reset);
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.reset);
  },
  directives: {
    ClickOutside: ClickOutside
  },
  props: {
    content: String,
    placement: {
      type: String,
      default: 'top'
    },
    gutter: {
      type: Number,
      default: 10
    }
  },
  methods: {
    reset: function reset() {
      if (this.show) {
        this.init(true);
      }
    },
    init: function init(isReset) {
      var trigger = this.$refs.trigger;
      var popover = this.$refs.popover;

      if (!isReset) {
        this.show = false;
      }

      switch (this.placement) {
        case 'top':
          this.position.left = trigger.offsetLeft - popover.offsetWidth / 2 + trigger.offsetWidth / 2;
          this.position.top = 0 - popover.offsetHeight - this.gutter;
          break;

        case 'left':
          this.position.left = trigger.offsetLeft - popover.offsetWidth - this.gutter;
          this.position.top = -trigger.offsetHeight / 2;
          break;

        case 'right':
          this.position.left = trigger.offsetLeft + trigger.offsetWidth + this.gutter;
          this.position.top = -trigger.offsetHeight / 2;
          break;

        case 'bottom':
          this.position.left = trigger.offsetLeft - popover.offsetWidth / 2 + trigger.offsetWidth / 2;
          this.position.top = 0 + trigger.offsetHeight + this.gutter;
          break;

        default:
          console.warn('Wrong placement prop');
      }

      this.popoverStyle = {
        top: this.position.top + this.gutter + 'px',
        left: this.position.left + 'px',
        display: isReset ? this.popoverStyle.display : 'none'
      };
    },
    onClickedOutside: function onClickedOutside() {
      if (this.show) {
        this.show = false;
        this.$emit('on-hide');
      }
    },
    toggle: function toggle() {
      var _this2 = this;

      this.show = !this.show;

      if (this.show) {
        this.$nextTick(function () {
          _this2.init(true);
        });
      }

      this.$emit("on-".concat(this.show === true ? 'show' : 'hide'));
    }
  },
  data: function data() {
    return {
      position: {
        top: 0,
        left: 0
      },
      show: true,
      popoverStyle: {}
    };
  },
  computed: {
    arrowClass: function arrowClass() {
      return {
        'tp-vux-popover-arrow': true,
        'tp-vux-popover-arrow-up': this.placement === 'bottom',
        'tp-vux-popover-arrow-right': this.placement === 'left',
        'tp-vux-popover-arrow-left': this.placement === 'right',
        'tp-vux-popover-arrow-down': this.placement === 'top'
      };
    }
  }
};